<template>
  <v-container>
    <v-fade-transition>
      <v-btn fab color="primary" class="fab-button" @click="toggleSearch">
        <v-icon>{{ showSearch ? 'mdi-close' : 'mdi-magnify' }}</v-icon>
      </v-btn>
    </v-fade-transition>
    <v-fade-transition>
      <v-text-field
        v-if="showSearch"
        v-model="$store.state.general.global_search"
        ref="searchInput"
        label="Suche..."
        class="search-field elevation-5"
        outlined
        dense
        hide-details
      ></v-text-field>
    </v-fade-transition>
  </v-container>
</template>

<script>
export default {
  name: "gnrl_magnify",
  data() {
    return {
      showSearch: false
    };
  },
  methods: {
    toggleSearch() {
      this.showSearch = !this.showSearch;


      this.$nextTick(() => {
        if (this.showSearch) {
          this.$refs.searchInput.focus(); // Automatisch fokussieren
        }
      });

      if (!this.showSearch) this.setSearch('');
    },
    handleShortcut(event) {
      if ((event.ctrlKey || event.metaKey) && event.key === "f") {
        event.preventDefault(); // Standard-Browser-Suche verhindern
        if(this.showSearch){
          this.setSearch('')
        }
        this.toggleSearch();

      }
      if (event.key === "Escape" && this.showSearch) {
        this.showSearch = false
        this.setSearch('');
      }
    },
    setSearch(str){
      this.$store.state.general.global_search = str
    },
  },
  mounted() {
    window.addEventListener("keydown", this.handleShortcut);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleShortcut);
  },
};
</script>

<style scoped>
.fab-button {
  position: fixed;
  bottom: 32px;
  right: 16px;
}

.search-field {
  position: fixed;
  bottom: 42px;
  right: 80px;
  width: 250px;
}
</style>
